import styled from 'styled-components';

import { Text } from '@/nova/components';
import { CFG } from '../../../../../theme/configurator-tokens';
import { MOBILE, MOBILE_ANIM } from '../../mobile.tokens';

export const Overlay = styled.div<{ $shown: boolean }>`
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  flex-direction: column;
  background: ${MOBILE.previewBg};
  transition: opacity ${MOBILE_ANIM.previewFadeMs}ms ease;
  opacity: ${({ $shown }) => ($shown ? 1 : 0)};
  padding-top: env(safe-area-inset-top, 0px);
`;

export const Header = styled.div`
  position: relative;
  height: 50px;
  flex-shrink: 0;
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  cursor: pointer;
  align-items: center;
  gap: 10px;
  padding: 7px 7px 7px 16px;
  background: none;
  border: none;
`;

export const CloseLabel = styled(Text)`
  font-size: 16px;
  font-weight: 900;
  line-height: 1.1;
  color: ${CFG.brandText};
`;

export const CloseGlyph = styled.span`
  display: flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background: ${CFG.brand};
`;

export const Body = styled.div`
  position: relative;
  min-height: 0;
  flex: 1;
  overflow: hidden;
  /* Scope the loading placeholder's z-index here, and clip it to the rounded top. */
  isolation: isolate;
  border-radius: 16px 16px 0 0;
`;

// Sandbox the cross-origin preview (omit allow-top-navigation so a framed site can't
// redirect the studio tab); the URL is already scheme-validated by buildPreviewUrl.
export const Frame = styled.iframe.attrs({ sandbox: 'allow-scripts allow-same-origin allow-forms allow-popups' })<{ $shown: boolean }>`
  height: 100%;
  width: 100%;
  border: 0;
  opacity: ${({ $shown }) => ($shown ? 1 : 0)};
  transition: opacity ${MOBILE_ANIM.previewFadeMs}ms ease;
`;
